import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(16),
      background: theme.colors.blue[0],
      padding: rem(16),
      borderRadius: 8,
      [theme.fn.largerThan('sm')]: {
        padding: rem(24),
      },
    },
    heading: {
      borderLeft: `5px solid ${theme.colors.primaryBase}`,
      paddingLeft: 12,
    },
    headingText: {},
    cardRoot: {},
    cardThumbnail: {},
  }
})
